export const TOGGLE_EDUCATION_BAR = "TOGGLE_EDUCATION_BAR";
